import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap, delay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  
  constructor(private http: HttpClient) {}

  /**
   * Initialise l'application : auto-connexion + localisation
   */
  init(): Promise<any> {
    return new Promise((resolve) => {
     
      
      const existingToken = localStorage.getItem('microFinance');
      
      if (!existingToken) {
        // Pas de token, faire l'auto-connexion
        this.autoLogin().subscribe(
          (success) => {
            resolve(true);
          },
          (error) => {
            resolve(false);
          }
        );
      } else {
        // Token existe déjà
        resolve(true);
      }
    });
  }

  /**
   * Auto-connexion (logique extraite de AuthService)
   */
  private autoLogin(): Observable<boolean> {
    const url = `${environment.apiUrl}/auto-login`;
    
    return this.http.post<any>(url, {}).pipe(
      tap((res) => {
        if (res && res['data'] && res['data']['access_token']) {
          const tokenObj = res['data'];
          
          const infos = {
            id: tokenObj.id,
            matricule: tokenObj.matricule,
            firstName: tokenObj.firstName,
            lastName: tokenObj.lastName,
            email: tokenObj.email,
            telephone: tokenObj.telephone,
            secteuractivite: tokenObj.secteuractivite,
            profession: tokenObj.profession,
            adresse: tokenObj.adresse,
            genre: tokenObj.genre
          };
          
          const detail = {
            id_token: tokenObj.access_token,
            refresh_token: tokenObj.refresh_token,
            infos: infos,
            authorities: tokenObj.authorities
          };
          
          localStorage.setItem('microFinance', JSON.stringify(detail));
        }
      }),
      catchError((error) => {
        localStorage.removeItem('microFinance');
        return of(false);
      }),
      tap(() => true)
    );
  }
}